<template>
    <div>
        <report-header
            :title="title"
        />
        <b-card>
            <div v-if="!loaded">
                <img src="assets/ajax-loader.gif" style="padding: 10px;" />
            </div>
            <div id="report-body" v-if="loaded" class="w-100">
                <div v-if="summary && summary.length > 0" class="w-50">
                    <b-table-simple bordered>
                        <b-thead head-variant="dark">
                            <b-tr>
                                <b-th :colspan="2">
                                    Summary
                                </b-th>
                            </b-tr>
                        </b-thead>
                        <b-thead head-variant="light">
                            <b-tr>
                                <b-th>Type</b-th>
                                <b-th>Count</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr
                                :key="smry.cost_type_id"
                                v-for="smry in summary"
                            >
                                <b-td style="width: 40%;">
                                    <a
                                        href="#"
                                        v-scroll-to="gotoTable(smry.type)"
                                    >
                                        {{ smry.type }}
                                    </a>
                                </b-td>
                                <b-td style="width: 10%;">{{
                                    smry.count
                                }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td><b>Total</b></b-td>
                                <b-td
                                    ><b> {{ totalCount }} </b></b-td
                                >
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
                <div v-else>
                    <i>No records available</i>
                </div>
                <div v-for="obj in details" class="w-100" :key="obj.key">
                    <b-table-simple bordered :id="'table_' + obj.table.key">
                        <b-thead head-variant="dark">
                            <b-tr>
                                <b-th :colspan="5">
                                    {{ obj.table.title }}
                                </b-th>
                            </b-tr>
                        </b-thead>
                        <b-thead head-variant="light">
                            <b-tr>
                                <b-th
                                    v-for="(title, index) in obj.table.header"
                                    :key="index"
                                >
                                    {{ title }}
                                </b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(value, key) in obj.result" :key="key">
                                <b-td>
                                    <item-name
                                        :item="{
                                            name: value.item,
                                            encodedId: value.encoded_id
                                        }"
                                    />
                                </b-td>
                                <b-td>{{ value.category }}</b-td>
                                <b-td>{{ value.type }}</b-td>
                                <b-td
                                    ><span
                                        v-if="
                                            value.base_price &&
                                            value.base_price
                                                .toString()
                                                .indexOf('%') > -1
                                        "
                                    >
                                        {{ value.base_price }}
                                    </span>
                                    <span v-else>
                                        {{ _toCurrency(value.base_price) }}
                                    </span>
                                </b-td>
                                <b-td>{{ value.base_qty }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import ItemName from "@/components/commons/item-name";
import Report from "@/mixins/report.js";

export default {
    components: {
        ItemName,
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            meta: "",
            summary: [],
            details: [],
            title: "",
            refresh: 0,
            totalCount: 0
        };
    },
    mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.filterDateOption = true;
        self.data.isShowProvider = false;
        self.data.isShowDateTimeRange = false;
        self.data.isShowDateRange = false;
        self.data.isShowItemClass = true;
        self.data.isShowItemStatus = true;

        self._getSetting().then(() => {
            self.data.itemClass = 0;
            self.data.status = 2;
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", function (params) {
            self.refresh = 1;
            if (params) {
                self.data.itemClass = params.itemClass;
                self.data.status = params.status;
            }
            self.init();
        });
        self.$root.$on("items-by-price-type:refresh", function () {
            self.refresh = 1;
            self.data.itemClass = 0;
            self.init();
        });
        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.$root.$off("report-filter-date-range:refresh");
        this.data.isShowDateTimeRange = false;
        this.data.isShowItemClass = false;
        this.data.isShowDateRange = true;
    },
    methods: {
        init(params) {
            let self = this;
            self.loaded = false;
            self.totalCount = 0;
            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
                self.data.itemClass = params.itemClass;
                self.data.status = params.status;
            }
            self.$http
                .get(
                    process.env.BARRAMUNDI +
                        "report/reports/92?refresh=" +
                        self.refresh +
                        "&item_class=" +
                        self.data.itemClass +
                        "&status=" +
                        self.data.status
                )
                .then(response => {
                    if (response) {
                        const res = response.data;
                        self.summary = res.response.resource.summary;
                        self.details = res.response.resource.details;
                        self.title = res.response.resource.meta.title;
                        self.dynamicPageTitle(self.title);
                        self.loaded = true;
                        self.locale = res.response.resource.meta.locale;
                        for (let n = 0; n < self.summary.length; n++) {
                            self.totalCount += self.summary[n].count;
                        }

                        if (res.response.resource.meta.item_class) {
                            self.data.itemClass =
                                res.response.resource.meta.item_class;
                        }
                    }
                });
        },
        gotoTable(name) {
            let mapping = {
                "Fixed Price": "1",
                "Latest Cost (Markup)": "2",
                "Average Cost (Markup)": "3",
                "Highest Cost (Markup)": "4",
                "Lowest Cost (Markup)": "5"
            };

            return "#table_" + mapping[name];
        }
    }
};
</script>
<style>
.total {
    font-weight: bold;
}
</style>
